<template>
  <div
    class="share-message"
    :class="{'share-message--not-empty': value.length}"
  >
    <textarea
      class="share-message_textarea"
      :value="value"
      @input="onInput"
    />
    <span class="share-message_placeholder">{{ placeholder }}</span>
  </div>
</template>

<script>
  export default {
    name: 'ShareModalMessage',
    props: {
      value: {
        type: String, default: '',
      },
      placeholder: {
        type: String, default: 'Your message',
      },
    },
    methods: {
      onInput(e) {
        const rawMsg = e.target.value;
        this.$emit('input', rawMsg);
      }
    },
  };
</script>

<style lang="scss" scoped>
  $list-gap: 4px;
  $input-color: rgba(#000, .5);
  .share-message {
    position: relative;
    width: 100%;
    margin-bottom: 16px;
  }
  .share-message_placeholder {
    position: absolute;
    left: 11px;
    top: 11px;
    background-color: #fff;
    padding: 0 5px;
    pointer-events: none;
    font-size: 18px;
    transition: transform .3s;
    transform-origin: left;
    color: $input-color;
    .share-message_textarea:focus + &,
    .share-message--not-empty & {
      transform: translate(0, -100%) scale(0.75);
    }
  }
  .share-message_textarea {
    height: 128px;
    resize: none;
    width: 100%;
    font-size: 16px;
    border-radius: 10px;
    padding: 11px;
    margin: 0;
    border: 1px solid $input-color;
    &:focus {
      outline: none;
      border: 1px solid $color-blue;
      + .share-message_placeholder {
        color: $color-blue;
      }
    }
  }

</style>
